module.exports = __webpack_public_path__ + "static/media/YM76_2.0a2456bc.jpg";